import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useForm } from '@laramie/ui';
import { InputFormula, InputLista, ToolbarFormula, Accordion, FormLabel, Modal, CheckboxButton, CheckboxButtonGroup, FormError } from '../../common';
import {validateFormula} from '../../../utils/validator';
import {TIPS} from "../../../consts/tips";


const EmisionCalculoModal = (props) => {

    const entityInit = {
        id: 0,
        idEmisionDefinicion: 0,
        idTipoEmisionCalculo: 0,
        codigo: "",
        nombre: "",
        descripcion: "",
        guardaValor: false,
        formula: "",
        soloLectura: false,
        orden: 0,
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        listCalculos: [],
        listVariables: [],
        listFunciones: [],
        listParametros: [],
        listElementos: [],
        listTiposDeclaracionJurada: []
    });

    const [cabeceraOpen, setCabeceraOpen] = useState(true);

    const [formulaOpen, setFormulaOpen] = useState(true);

    const [toolbar, setToolbar] = useState({
        show: false,
        horizontal: false
    });

    const [editor, setEditor] = useState({
        fontSize: "md",
        expand: false,
        disabled: props.disabled
    });

    const [queueEvents, setQueueEvents] = useState({
        timestamps: null,
        queue: []
    });

    const mount = () => {
        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                listCalculos: props.data.listCalculos,
                listVariables: props.data.listVariables,
                listFunciones: props.data.listFunciones,
                listParametros: props.data.listParametros,
                listElementos: props.data.listElementos,
                listTiposDeclaracionJurada: props.data.listTiposDeclaracionJurada
            };
        });
        formSet({
            idTipoEmisionCalculo: props.data.entity.idTipoEmisionCalculo,
            codigo: props.data.entity.codigo,
            nombre: props.data.entity.nombre,
            descripcion: props.data.entity.descripcion,
            guardaValor: props.data.entity.guardaValor,
            formula: props.data.entity.formula,
            orden: props.data.entity.orden
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoEmisionCalculo: 0,
        codigo: "",
        nombre: "",
        descripcion: "",
        guardaValor: false,
        formula: "",
        orden: 0,
    });

    //handles
    const handleToolbarFormulaToogleHorizontal = (horizontal) => {
        setToolbar(prevState => {
            return {...prevState, horizontal: horizontal};
        });
    }
    const handleToolbarFormulaSelect = (event) => {
        const timestamps = Date.now();
        let newQueue = queueEvents.queue.slice();
        newQueue.push({queueName: "Calculo", timestamps: timestamps, ...event});

        setQueueEvents({
            queue: newQueue,
            timestamps: timestamps
        });
    }

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickConfirm = () => {
        const errors = getErrors();
        if (errors.codigo || errors.nombre || errors.descripcion || errors.idTipoEmisionCalculo) setCabeceraOpen(true);
        if (errors.formula) setFormulaOpen(true);

        if (validate()) {

            let row = CloneObject(state.entity);
            row.idTipoEmisionCalculo = parseInt(formValues.idTipoEmisionCalculo);
            row.codigo = formValues.codigo;
            row.nombre = formValues.nombre;
            row.descripcion = formValues.descripcion;
            row.guardaValor = formValues.guardaValor;
            row.formula = formValues.formula;
            row.orden = parseInt(formValues.orden);

            props.onConfirm(row);
        }
        ;
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoEmisionCalculo <= 0) errors.idTipoEmisionCalculo = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.codigo.length <= 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.nombre.length <= 0) errors.nombre = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.descripcion.length <= 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;

        if (formValues.formula.length <= 0) errors.formula = VALIDATION_MESSAGE.REQUIRED;
        else {
            const error = validateFormula(formValues.formula);
            if (error) errors.formula = `Fórmula incorrecta: ${error}`;
        }

        return errors;
    }

    function ToggleEditorDisabled() {
        setEditor(prevState => {
            return {...prevState, disabled: !editor.disabled};
        });
    }

    function ToggleFormulaExpand() {
        if (!editor.expand && cabeceraOpen) {
            setCabeceraOpen(false);
        }
        setEditor(prevState => {
            return {...prevState, expand: !prevState.expand};
        });
    }

    function SetFormulaFontSizeUp() {
        let fontSize = editor.fontSize;
        if (fontSize === "xm") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "md";
        else if (fontSize === "md") fontSize = "lg";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function SetFormulaFontSizeDown() {
        let fontSize = editor.fontSize;
        if (fontSize === "lg") fontSize = "md";
        else if (fontSize === "md") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "xm";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function ToogleToolbarShow() {
        setToolbar(prevState => {
            return {
                show: !prevState.show,
                horizontal: false
            };
        });
    }


    return (
        <Modal
            size={(toolbar.show && !toolbar.horizontal) ? "xl" : "lg"}
            allowFullscreen
            title={`Cálculo: ${(state.entity.id > 0) ? state.entity.nombre : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.EMISION_CALCULO_MODAL}
            onEscape={() => props.onDismiss()}
            body={(
                            <div className="row">

                                <div id="panel-main"
                                     className={(toolbar.show && !toolbar.horizontal) ? "col-12 col-lg-8" : "col-12"}>

                                    <Accordion title="Datos" open={cabeceraOpen} onToggle={setCabeceraOpen}>
                                        <div className="row form-basic">
                                            <div className="col-12 col-lg-5">
                                                <FormLabel htmlFor="codigo" required>Código</FormLabel>
                                                <input
                                                    name="codigo"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={50}
                                                    className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                                    value={formValues.codigo}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('codigo')} />
                                            </div>
                                            <div className="col-12 col-lg-7">
                                                <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                                                <input
                                                    name="nombre"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={250}
                                                    className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                                                    value={formValues.nombre}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('nombre')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                                <input
                                                    name="descripcion"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={1000}
                                                    className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                                    value={formValues.descripcion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('descripcion')} />
                                            </div>
                                            <div className="col-12 col-lg-3">
                                                <FormLabel htmlFor="idTipoEmisionCalculo" required>Tipo
                                                    cálculo</FormLabel>
                                                <InputLista
                                                    name="idTipoEmisionCalculo"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoEmisionCalculo') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoEmisionCalculo}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    lista="TipoEmisionCalculo"
                                                />
                                                <FormError message={errorOf('idTipoEmisionCalculo')} />
                                            </div>
                                            <div className="col-6 col-lg-2">
                                                <label htmlFor="orden" className="form-label">Orden</label>
                                                <input
                                                    name="orden"
                                                    type="number"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.orden}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="col-6 col-lg-3">
                                                <CheckboxButtonGroup label="Opciones">
                                                    <CheckboxButton
                                                        name="guardaValor"
                                                        label="Guardar valor"
                                                        checked={formValues.guardaValor}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                        </div>
                                    </Accordion>

                                    <Accordion
                                        title="Fórmula"
                                        className="m-top-15"
                                        open={formulaOpen}
                                        onToggle={setFormulaOpen}
                                        actions={
                                            <div className="action m-right-20 m-top-10">
                                                {!props.disabled && !toolbar.show &&
                                                    <div onClick={(event) => ToogleToolbarShow()}
                                                         className="link float-end m-left-5">
                                                        <span className="material-symbols-outlined"
                                                              title="Mostrar asistente de fórmulas">function</span>
                                                    </div>
                                                }
                                                <div onClick={(event) => ToggleFormulaExpand()}
                                                     className="link float-end m-left-5">
                                                    {(editor.expand) ? <span className="material-symbols-outlined"
                                                                             title="Contraer editor de fórmula">zoom_in_map</span> :
                                                        <span className="material-symbols-outlined"
                                                              title="Expandir editor de fórmula">zoom_out_map</span>}
                                                </div>
                                                <div onClick={(event) => SetFormulaFontSizeDown()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Disminuir tamaño de fuente">text_decrease</span>
                                                </div>
                                                <div onClick={(event) => SetFormulaFontSizeUp()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Aumentar tamaño de fuente">text_increase</span>
                                                </div>
                                                {!props.disabled &&
                                                    <div onClick={(event) => ToggleEditorDisabled()}
                                                         className="link float-end m-left-5">
                                                        <span className="material-symbols-outlined"
                                                              title={(editor.disabled) ? "Cambiar a modo edición" : "Cambiar a modo lectura"}>{(editor.disabled) ? "stylus" : "search"}</span>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    >
                                        <div className="row">
                                            <div className="col-12">
                                                <InputFormula
                                                    name="formula"
                                                    className={`form-control ${errorOf('formula') ? 'is-invalid' : ''}`}
                                                    fontSize={editor.fontSize}
                                                    maxLength={10000}
                                                    editorExpanded={editor.expand}
                                                    value={formValues.formula}
                                                    onChange={formHandle}
                                                    disabled={editor.disabled}
                                                    data={{
                                                        listCalculos: state.listCalculos,
                                                        listVariables: state.listVariables,
                                                        listFunciones: state.listFunciones,
                                                        listParametros: state.listParametros,
                                                        listElementos: state.listElementos,
                                                        listTiposDeclaracionJurada: state.listTiposDeclaracionJurada
                                                    }}
                                                    queueEvents={queueEvents}
                                                    queueName="Calculo"
                                                />
                                                <FormError message={errorOf('formula')} />
                                            </div>
                                        </div>
                                    </Accordion>

                                </div>

                                {toolbar.show &&
                                    <ToolbarFormula
                                        data={{
                                            listCalculos: state.listCalculos.filter(f => f.orden < formValues.orden),
                                            listVariables: state.listVariables,
                                            listFunciones: state.listFunciones,
                                            listParametros: state.listParametros,
                                            listElementos: state.listElementos,
                                            listTiposDeclaracionJurada: state.listTiposDeclaracionJurada
                                        }}
                                        onToogleHorizontal={handleToolbarFormulaToogleHorizontal}
                                        onSelect={handleToolbarFormulaSelect}
                                        onClose={ToogleToolbarShow}
                                        showRubros={props.procesaRubros}
                                        showCarteles={props.procesaCarteles}
                                        showElementos={props.procesaElementos}
                                    />
                                }

                            </div>

            )}
            footerClassName="modal-footer-unset"
            footer={(<>
                            {props.onMovePrevious &&
                                <button className="btn btn-i" data-dismiss="modal"
                                        onClick={(event) => props.onMovePrevious()}>
                                    <span className="material-symbols-outlined tooltip-container"
                                          title='Anterior'>chevron_left</span></button>
                            }
                            {props.onMoveNext &&
                                <button className="btn btn-i" data-dismiss="modal"
                                        onClick={(event) => props.onMoveNext()}>
                                    <span className="material-symbols-outlined tooltip-container"
                                          title='Siguiente'>chevron_right</span></button>
                            }
                            {!props.disabled && <>
                                <button className="btn btn-primary float-end" data-dismiss="modal"
                                        onClick={(event) => handleClickConfirm()}>Aceptar
                                </button>
                                <button className="btn btn-outline-primary float-end" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                            </>}
                            {props.disabled &&
                                <button className="btn back-button float-start" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver</button>
                            }
            </>)}
        />
    );
}

EmisionCalculoModal.propTypes = {
    disabled: bool,
    procesaRubros: bool,
    procesaCarteles: bool,
    procesaElementos: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    onMovePrevious: func,
    onMoveNext: func,
};

EmisionCalculoModal.defaultProps = {
    disabled: false,
    procesaRubros: false,
    procesaCarteles: false,
    procesaElementos: false,
    onMovePrevious: null,
    onMoveNext: null
};

export default EmisionCalculoModal;